export default __webpack_public_path__ + "static/media/business.4a020578.webp";